import http from "../../http-common";
import StockAdjustment from '../stock-adjustment/StockAdjustment';
import { Receipt } from '@material-ui/icons';

const get = (data) => http.post("/StockConsult/FilterStockConsult", data);

const getByCodeProduct = (data) => http.post("/ReceiptProduct/GetByCodeProduct", data);

const getByBarCode = (data) => http.post("/ReceiptProduct/GetByBarCode", data);

const getByProductName = (data) => http.post("/ReceiptProduct/GetByProductName", data);

const saveHeader = (data) => http.post("/ReceiptProduct/SaveHeader", data);

const saveItens = (data) => http.post("/ReceiptProduct/SaveItens", data);

const sendPrint = (data) => http.post("/ReceiptProduct/SendPrint", data);

export default { get, getByCodeProduct, getByBarCode, getByProductName, saveHeader, saveItens, sendPrint };
